import { CalendarDateTime } from '@internationalized/date';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { handleRollover } from './util';

/**
 * By default, HeroUI's TimeInput doesn't handle rollover. This wraps the
 * setTime function to handle rolling over from 11:59pm to 12:00am, etc.
 */
export function useOnChangeTime(setTime: Dispatch<SetStateAction<CalendarDateTime | null>>) {
  return useCallback(
    (time: CalendarDateTime | null) => {
      setTime(prev => handleRollover(prev, time));
    },
    [setTime],
  );
}
